import React from 'react'
import { BarDatum, ResponsiveBarCanvas } from '@nivo/bar'
import { Box } from '@material-ui/core'
import { formatPrice } from '../../../util/formatters'
import { BarTooltip } from './BarTooltip'
import { Legends } from './Legends'

const COLOR_SCHEME = [
  '#a4a4a6',
  '#c0d4fd',
  '#dec55b',
  '#9dd354',
  '#608D24',
  '#9C851F',
]

const LABEL_MAX_LENGTH = 27

type Props = {
  data: BarDatum[]
  keys: string[]
  xFormatter: (id: string) => string
  yFormatter: (value: number) => string
}

export function BarChart({
  data,
  keys,
  xFormatter,
  yFormatter,
}: Props): React.ReactElement {
  const formatLabel = (value: string | number): string => {
    const formattedValue = value.toString()

    return formattedValue.length > LABEL_MAX_LENGTH
      ? `${formattedValue.slice(0, LABEL_MAX_LENGTH - 2)} ...`
      : formattedValue
  }
  const mapLegendData = (key: string, index: number) => ({
    label: xFormatter(key),
    color: COLOR_SCHEME[index % COLOR_SCHEME.length],
  })

  return (
    <>
      <Box height="85%">
        <ResponsiveBarCanvas
          data={data}
          keys={keys}
          isInteractive
          enableLabel={false}
          indexBy="id"
          valueScale={{ type: 'linear' }}
          colors={COLOR_SCHEME}
          margin={{ top: 8, right: 48, bottom: 120, left: 80 }}
          padding={0.7}
          tooltip={({ id, value }) =>
            BarTooltip(xFormatter(String(id)), yFormatter(value))
          }
          axisLeft={{
            format: formatPrice,
          }}
          axisBottom={{
            format: formatLabel,
            tickSize: 0,
            tickPadding: 20,
            tickRotation: 30,
          }}
        />
      </Box>

      <Legends legendData={keys.map(mapLegendData)} />
    </>
  )
}
